/**
 * User: Rob Richard
 * Date: 1/14/15
 * Time: 1:26 PM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var PercentAdjustment = module.exports = SoaModel.extend();

var _ = require('underscore');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var Backbone = require('dibs-backbone');
var Period = require('bunsen/models/Period');
var Adjustment = require('bunsen/models/ecomm/Adjustment');
var Anchor = require('bunsen/models/Anchor');
var financialAmountMixin = require('bunsen/models/mixins/financialAmountMixin');
var getAdjustmentProperty;
var hasReference;

getAdjustmentProperty = function (name) {
    var adjustmentProperties = this.get('adjustmentProperties');
    var property;
    if (adjustmentProperties) {
        property = adjustmentProperties.findWhere({name: name});
    }
    return property && property.get('value');
};

hasReference = function (reference) {
    return this.get('reference') === reference;
};

_.extend(PercentAdjustment.prototype, {
    relations: [
        {
            key: 'totalAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'adjustmentProperties',
            relatedModel: SoaModel,
            type: Backbone.Many
        },
        {
            key: 'eligibleAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'sourceAnchor',
            relatedModel: Anchor,
            type: Backbone.One
        },
        {
            key: 'saleAdjustment',
            relatedModel: function () {
                // Adjustment requires PercentAdjustment
                // PercentAdjustment requires Adjustment
                // Seller Adjustment requires Adjustment
                // PercentAdjustment requires SellerAdjustment
                return require('bunsen/models/ecomm/SellerAdjustment');
            },
            type: Backbone.One
        }
    ],
    getReleaseDate: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_RELEASE_DATE),
    getStartingDate: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_STARTING_DATE),
    getNumberOfUnits: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_NUMBER_OF_UNITS),
    getEligibleCreditPeriod: _.partial(getAdjustmentProperty, Adjustment.PROPERTY_ELIGIBLE_CREDIT_PERIOD),
    getCreditPeriod: function () {
        var timeUnit = getAdjustmentProperty.call(this, 'creditPeriod.timeUnit');
        var numberOfUnits = getAdjustmentProperty.call(this, 'creditPeriod.numberOfUnits');
        return new Period({
            timeUnit: timeUnit,
            numberOfUnits: parseInt(numberOfUnits, 10)
        });
    },
    getCreditAmount: function () {
        var amount = getAdjustmentProperty.call(this, 'creditAmount.amount');
        var currency = getAdjustmentProperty.call(this, 'creditAmount.currency');
        return new FinancialAmount({
            amount: amount,
            currency: currency
        });
    },
    getEligibleAmount: function (currency) {
        return this._getFinancialAmount('eligibleAmount', currency);
    },
    isPromotionAdjustment: function () {
        var anchor = this.get('sourceAnchor');
        return anchor && anchor.isPromotion();
    },
    isMerchTaxAdjustment: _.partial(hasReference, Adjustment.REFERENCE_MERCHANDISE_TAX),
    isShippingTaxAdjustment: _.partial(hasReference, Adjustment.REFERENCE_SHIPPING_TAX),
    isCommissionAdjustment: _.partial(hasReference, Adjustment.REFERENCE_COMMISSION),
    isProcessingFeeAdjustment: _.partial(hasReference, Adjustment.REFERENCE_PAYMENT_PROCESSING_FEE),
    isListingCreditAdjustment: _.partial(hasReference, Adjustment.REFERENCE_LISTING_CREDIT),
    isComplimentaryShipping: _.partial(hasReference, Adjustment.REFERENCE_COMPLIMENTARY_SHIPPING),
    isDealerCharge: _.partial(hasReference, Adjustment.REFERENCE_DEALER_CHARGE)
}, financialAmountMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/PercentAdjustment.js
// module id = 2045
// module chunks = 63